<template lang="pug">
  //- UNCOMMENT IF YOU DO NOT WANT PEOPLE TO INTERACT WITH THIS PART OF THE WEBAPP (and make sure to comment the other div out)
  //- div(:style="{display:'block', textAlign:'center'}")
  //-   img(src='@/assets/img/agDisabled.jpg' alt='usit photo' :style="{height:'40vh', borderLeftStyle:'solid'}")
  .content
    .md-layout.md-gutter.md-alignment-center-center(v-if="user.teaching_role != 'SA'")
      .md-layout-item.md-size-70.md-medium-size-85.md-xsmall-size-100
        AnalystGroupOverview(v-if="user.analyst_group" :groupID="user.analyst_group")
        AnalystGroupRegister(v-else)
    .md-layout.md-gutter.md-alignment-center-top(v-else)
      .md-layout-item.md-size-50.md-medium-size-85.md-xsmall-size-100
        AnalystGroupOverview(:groupID="user.analyst_group")
      .md-layout-item.md-size-50.md-medium-size-85.md-xsmall-size-100
        AnalystGroupRoster(:groupID="user.analyst_group")
</template>


<script>
import AnalystGroupOverview from '@/pages/AnalystGroup/AnalystGroupOverview.vue';
import AnalystGroupRegister from '@/pages/AnalystGroup/AnalystGroupRegister.vue';
import AnalystGroupRoster from '@/pages/AnalystGroup/AnalystGroupRoster.vue';

export default {
  components: {
    AnalystGroupOverview,
    AnalystGroupRegister,
    AnalystGroupRoster
  },
  data() {
    return {
      user: null,
    };
  },
  created() {
    this.user = this.$store.state.user;
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/AnalystGroup/AnalystGroupLanding.vue